/*
 * Created by duydatpham@gmail.com on 28/07/2021
 * Copyright (c) 2021 duydatpham@gmail.com
 */

import { useFormikContext } from "formik"
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react"
import debounce from 'lodash/debounce'
import { Dropdown, Modal } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import Divider from "@material-ui/core/Divider"
import { FieldFeedbackLabel } from "../_metronic/_partials/controls"
import { useIntl } from "react-intl"
import { useLazyQuery } from "@apollo/client"
import query_scGetCategorySuggestion from "../graphql/query_scGetCategorySuggestion"
import { useToasts } from "react-toast-notifications"

const CategoryList = memo(({ index, categoriesSelected, setCategoriesSelected, setIsDoneSelect, scrollToX, categories }) => {
    let current_parent = categoriesSelected[index - 1]
    let current_select = categoriesSelected[index]
    const data = categories[index == 0 ? 'root' : current_parent?.id] || []
    return (
        <div className="flex-grow-1 list-group py-2" style={{
            position: 'relative',
            height: '100%', overflowY: 'scroll',
            minWidth: 300
        }} >
            {
                (index == 0 || !!current_parent) && data?.map((_category, __index) => {
                    let selected = current_select?.id == _category.id;
                    let childs = categories[_category.id] || [];
                    return (
                        <a key={`cate-gory-${_category.id}`} href="#"
                            className="d-flex justify-content-between align-items-center px-4 py-2 "
                            onClick={e => {
                                e.preventDefault();
                                !!scrollToX && scrollToX(index)
                                let newcategoriesSelected = categoriesSelected.slice(0, index)
                                newcategoriesSelected[index] = _category
                                setCategoriesSelected(newcategoriesSelected)
                                setIsDoneSelect(childs.length == 0)
                            }}
                        >
                            <span className={selected ? 'text-primary' : 'text-secondary'} >{`${__index + 1}. ${_category.display_name}`}</span>
                            {childs?.length > 0 && <i className={`fas fa-angle-right ${selected ? 'text-primary' : 'text-secondary'}`} > </i>}
                        </a>
                    )
                })
            }
        </div>
    )
})


const CustomMenu = React.forwardRef(
    ({ className, 'aria-labelledby': labeledBy, close, categories, name, selected, onSelect, hideConfirm, disableFeedback }, ref) => {
        const { setFieldValue, values } = useFormikContext()
        const { formatMessage } = useIntl()
        const [categoriesSelected, setCategoriesSelected] = useState([])
        const [categoriesTree, setCategoriesTree] = useState(categories) // component này được gắn vào 1 lần khi mở lên lần đầu tiên, các lần mở sau chỉ là visiable ra 
        useEffect(() => {
            if (values[name])
                setCategoriesSelected(values[name])
        }, [values[name]])
        const [isDoneSelect, setIsDoneSelect] = useState(false)
        const [showConfirm, setShowConfirm] = useState(false)

        const _refDiv = useRef()
        const _scrollTo = useCallback((index) => {
            if (!!_refDiv.current) {
                requestAnimationFrame(() => _refDiv.current.scrollTo(index * 200, 0))
            }
        }, [_refDiv.current])

        // const [searchTerm, setSearchTerm] = useState(""); // với ngành hàng cha thì chỉ lấy 1, ngành hàng con thì lấy toàn bộ, categories đang lưu trữ dạng cây

        const debouncedSearch = useCallback(
            debounce((term) => {
                // setSearchTerm(term)
                // xử lý search luôn ở đây và update vào categoriesTree
                const listCategories = Object.values(categories).flat();
                const categoriesMatched = listCategories.filter(c => c?.display_name?.toLowerCase()?.includes(term?.toLowerCase()) || term?.toLowerCase().includes(c?.display_name?.toLowerCase()))
                const _categoriesTree = {}
                categoriesMatched.forEach(c => {
                    // tạo tầng cha
                    let current_id = c?.id
                    while (!!current_id) {
                        const _current = listCategories.find(_ => _?.id == current_id) // tồn tại current_id thì luôn tìm được _current
                        let parent_id = _current?.parent_id;
                        const key = !!parent_id ? parent_id : "root"

                        if (!_categoriesTree[key]) {
                            // nếu chưa tạo tầng này
                            _categoriesTree[key] = [_current]
                        }
                        else {
                            // nếu đã có tầng này rồi
                            if (_categoriesTree[key]?.findIndex(_ => _?.id == _current?.id) == -1) {
                                // chưa tồn tại trong tầng này thì push vào
                                _categoriesTree[key].push(_current)
                            }
                        }
                        current_id = parent_id
                    }

                    // tạo tầng con
                    let queueId = [c?.id]
                    while (queueId.length > 0) {
                        let _id = queueId.shift();
                        if (!!categories[_id]?.length) {
                            _categoriesTree[_id] = categories[_id]; // gán đè luôn các thằng con (mặc kể replace phần xử lý data ~ luôn đúng?)
                            queueId.push(...categories[_id].map(_ => _?.id)) // push tiếp id các thằng con vào queue để duyệt tiếp (BFS)
                        }
                    }
                })
                setCategoriesTree(_categoriesTree)
            }, 1000),
            []
        );

        // console.log("search term", searchTerm);
        const handleChange = (e) => {
            // setSearchTerm(e.target.value);
            debouncedSearch(e.target.value);
        };

        return (
            <div
                ref={ref}
                className={className}
                aria-labelledby={labeledBy}
                style={{ width: '100%' }}
            >
                <div className="card card-custom">
                    <div ref={_refDiv} style={{ overflowX: 'scroll' }}>
                        <div style={{ width: 'fit-content' }} >
                            <p className="m-0 col-12 py-3" style={{ fontSize: "16px", fontWeight: 500 }}>{formatMessage({ defaultMessage: 'NGÀNH HÀNG' })}</p>
                            <div className="col-6 input-icon pr-1" >
                                <input type="text" className="form-control" placeholder={formatMessage({ defaultMessage: "Tìm kiếm ngành hàng" })}
                                    style={{ height: 40 }}
                                    onChange={handleChange}
                                    defaultValue={''}
                                    onKeyDown={e => {
                                    }}
                                />
                                <span><i className="flaticon2-search-1 icon-md ml-6"></i></span>
                            </div>
                            <div className={'mx-4 my-4 d-flex flex-row align-items-center'} style={{ fontSize: 14 }} >
                                {formatMessage({ defaultMessage: 'Ngành hàng đang chọn' })}:&ensp;
                                {
                                    categoriesSelected.map((_category, index) => {
                                        return [
                                            index > 0 && <i key={`iright--${index}`} className={`fas fa-angle-right text-secondary mx-4`} > </i>,
                                            <span key={`iright----${index}`} className={'text-primary'} >{_category.display_name}</span>
                                        ]
                                    })
                                }
                            </div>
                            <Divider orientation='horizontal' />
                            <div className="card-body d-flex flex-row p-0" style={{ height: 250 }} >
                                <CategoryList index={0} categoriesSelected={categoriesSelected} setCategoriesSelected={setCategoriesSelected} setIsDoneSelect={setIsDoneSelect} scrollToX={_scrollTo} categories={categoriesTree} />
                                <Divider orientation='vertical' variant='fullWidth' />
                                <CategoryList index={1} categoriesSelected={categoriesSelected} setCategoriesSelected={setCategoriesSelected} setIsDoneSelect={setIsDoneSelect} scrollToX={_scrollTo} categories={categoriesTree} />
                                <Divider orientation='vertical' variant='fullWidth' />
                                <CategoryList index={2} categoriesSelected={categoriesSelected} setCategoriesSelected={setCategoriesSelected} setIsDoneSelect={setIsDoneSelect} scrollToX={_scrollTo} categories={categoriesTree} />
                                {
                                    categoriesSelected.slice(2, 100).map((_category, index) => {
                                        if ((categoriesTree[_category.id] || []).length > 0) {
                                            return [
                                                <Divider key={`divider-${index}`} orientation='vertical' variant='fullWidth' />,
                                                <CategoryList key={`CategoryList-${index}`} index={index + 2 + 1} categoriesSelected={categoriesSelected} setCategoriesSelected={setCategoriesSelected} setIsDoneSelect={setIsDoneSelect} scrollToX={_scrollTo} categories={categoriesTree} />
                                            ]
                                        }
                                        return null;
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="card-footer d-flex flex-row-reverse py-3">
                        <button
                            type="button"
                            className="btn btn-primary btn-elevate"
                            disabled={!isDoneSelect}
                            onClick={e => {
                                e.preventDefault();
                                setFieldValue('__changed__', true);
                                if (!!selected
                                    && selected.id != categoriesSelected[categoriesSelected.length - 1].id
                                    && !hideConfirm
                                    && !disableFeedback) {
                                    setShowConfirm(true)
                                } else {
                                    setFieldValue(name, [...categoriesSelected], true)
                                    console.log(categoriesSelected, "xxxx");
                                    !!onSelect && onSelect(categoriesSelected[categoriesSelected.length - 1])
                                }
                                !!close && close()
                            }}
                        >
                            <FormattedMessage defaultMessage="XÁC NHẬN" />
                        </button>
                        <button
                            type="button"
                            className="btn btn-light btn-elevate mr-3"
                            onClick={e => {
                                e.preventDefault();
                                !!close && close()
                            }}
                        >
                            <FormattedMessage defaultMessage="ĐÓNG" />
                        </button>
                    </div>
                </div>
                {!disableFeedback && <Modal
                    show={showConfirm}
                    onHide={() => setShowConfirm(false)}
                    aria-labelledby="example-modal-sizes-title-sm"
                    centered
                >
                    <Modal.Body className="overlay overlay-block cursor-default text-center" >
                        {formatMessage({ defaultMessage: 'Việc thay đổi danh mục có thể bị xóa một phần thông tin bạn đã nhập bên dưới (nếu những thông tin đó không còn phù hợp với danh mục hiện tại bạn chọn). Bạn vẫn muốn tiếp tục' })}?
                    </Modal.Body>
                    <Modal.Footer className="form" style={{ borderTop: 'none', justifyContent: 'center', paddingTop: 0 }} >
                        <div className="form-group">
                            <button
                                type="button"
                                onClick={() => setShowConfirm(false)}
                                className="btn btn-light btn-elevate mr-3"
                                style={{ width: 100 }}
                            >
                                <FormattedMessage defaultMessage="ĐÓNG" />
                            </button>
                            <button
                                type="button"
                                onClick={() => {
                                    setFieldValue(name, [...categoriesSelected])
                                    onSelect(categoriesSelected[categoriesSelected.length - 1])
                                    // setAttributesSelected([])
                                    setShowConfirm(false)
                                }}
                                className="btn btn-primary btn-elevate"
                                style={{ width: 100 }}
                            >
                                <FormattedMessage defaultMessage="XÁC NHẬN" />
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div >
        );
    },
);

const CustomToggle = React.forwardRef(({ onClick, selected, name, disableInputStyle }, ref) => {
    const { values, touched, submitCount, errors, setFieldTouched } = useFormikContext()
    const { formatMessage } = useIntl();
    const isInvalid = (submitCount > 0 || touched[name]) && errors[name];
    return <>
        <input type="text" name={name} className={`form-control `} placeholder={formatMessage({ defaultMessage: "Chọn ngành hàng" })} ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
            value={!!values[name] ? values[name].map(_cate => _cate.display_name).join('  >  ') : ''}
            onChange={() => { }}
            onFocus={() => setFieldTouched(name, true)}
            style={!disableInputStyle ? { background: '#F7F7FA', border: isInvalid ? '1px solid #F5222D' : 'none' } : { paddingRight: !!selected ? 30 : 0 }}
            autoComplete='off'
        />
        <FieldFeedbackLabel
            error={errors[name]}
            touched={isInvalid}
        />
    </>
});

export default memo((props) => {
    const { formatMessage } = useIntl();
    const [getCategorySuggestion, { data, loading }] = useLazyQuery(query_scGetCategorySuggestion, {
        variables: {
            product_name: props?.suggestName,
            store_id: props?.store_id
        }
    })

    useEffect(() => {
        if (!!props?.suggestName) {
            getCategorySuggestion()
        }
    }, [props?.suggestName])

    return (
        <div className="form-group row">
            {!props.hideLabel && <label className={`col-12 col-form-label ${!props.disablePaddingTop ? 'mt-4' : ''}`}>{formatMessage({ defaultMessage: 'Ngành hàng' })} <span className='text-danger' > *</span></label>}
            <div className="col-12 input-group">
                <Dropdown style={{ width: '100%' }} drop={'down'} >
                    <Dropdown.Toggle as={CustomToggle} style={{ width: '100%' }} {...props} >
                        <FormattedMessage defaultMessage="GIAN HÀNG/KÊNH BÁN" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu as={CustomMenu} {...props} >
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            {(!!props?.suggestName && loading) && <CircleProgress />}
            {!!props?.suggestName && !!data?.scGetCategorySuggestion?.length &&
                <EllipsisContainer data={data?.scGetCategorySuggestion} prefix={props?.name} onSelect={props.onSelect} listCategories={Object.values(props.categories)?.flat()} />
            }
        </div>
    )
})

const EllipsisContainer = ({ data, prefix, onSelect, listCategories }) => {
    const { formatMessage } = useIntl();
    const containerRef = useRef(null)
    const [index, setIndex] = useState(-1);
    const [ellipsis, setEllipsis] = useState(true);

    // console.log("xxxxxxxxx", data);
    useEffect(() => {
        handleOverflow()
        window.addEventListener('resize', handleOverflow);

        return () => {
            window.removeEventListener('resize', handleOverflow);
        }
    }, [prefix, ellipsis])

    function handleOverflow() {
        if (ellipsis) {
            // trường hợp đang ẩn bớt
            const container = containerRef.current;
            const containerRect = container.getBoundingClientRect();
            const listItems = container.querySelectorAll(`.${prefix}-item-category-suggestion`);
            // const _ellipsis = container.querySelector(prefix + "-ellipsis")
            let lastVisibleIndex = -1;
            for (let index = 0; index < listItems.length; index++) {
                const item = listItems[index];
                const itemRect = item.getBoundingClientRect();
                const relativeTop = itemRect.top - containerRect.top;

                // Check if the item is within the container's height
                if (relativeTop == 0) {
                    // if (relativeTop + itemRect.height <= containerRect.height) {
                    lastVisibleIndex = index;
                } else {
                    // Stop the loop if we've found an item that's outside the container
                    // break
                }
            }

            // const ellipsisTop = _ellipsis.top - containerRect.top;
            if (lastVisibleIndex == -1) lastVisibleIndex = 0;
            setIndex(lastVisibleIndex);
        }
    }

    const _data = data
    return <div className="col-12" style={{ paddingTop: "6px" }}>
        <div className={`d-flex ${prefix}-item-category-suggestion-container`}
            style={{ flexWrap: "wrap", position: 'relative' }}
            ref={containerRef}>
            <span style={{ lineHeight: "35px" }}>
                {formatMessage({ defaultMessage: "Gợi ý: " })}
            </span>
            {_data?.map((_suggest, _index) => {
                const _hideIndex = index == -1 ? _data?.length : index + 1
                return <>
                    {_index == _hideIndex && _hideIndex < _data?.length &&
                        <div className={prefix + "-ellipsis"} style={{
                            padding: "8px 12px",
                            background: "#dcdcdc",
                            color: "#212121",
                            borderRadius: "32px",
                            marginBottom: "6px",
                            marginLeft: "6px",
                            cursor: "pointer",
                            alignSelf: "flex-end",
                            display: ellipsis ? "block" : "none"
                        }}
                            onClick={() => {
                                setEllipsis(false);
                                setIndex(_data?.length - 1)
                            }}
                        >...</div>}
                    <Item prefix={prefix} listCategories={listCategories} idx={_index} onSelect={onSelect} suggest={_suggest} hide={_index >= _hideIndex} />
                </>
            })}
        </div>
    </div>
}

const Item = ({ prefix, listCategories, idx, onSelect, suggest, hide }) => {
    const { formatMessage } = useIntl();
    const { setFieldValue, values } = useFormikContext()
    const { addToast } = useToasts();

    const isFocus = useMemo(() => {
        const listCate = values[prefix] ?? [];
        let sc_category_id = suggest?.sc_category_id
        if (!!listCate?.length) {
            let _ = listCate[listCate.length - 1];
            if (_?.id == sc_category_id) return true
        }
        return false;
    }, [values[prefix], suggest])

    return <a href={'#'}
        key={`--index-${idx}`}
        style={{
            padding: "0px 12px",
            background: isFocus ? "rgba(254, 86, 41, 0.51)" : "#dcdcdc",
            color: "#212121",
            borderRadius: "32px",
            marginBottom: hide ? 0 : "6px",
            marginLeft: "6px",
            height: hide ? "0" : "35px",
            lineHeight: hide ? "0" : "35px",
            overflow: "hidden"
        }}
        className={`${prefix}-item-category-suggestion`}
        onClick={e => {
            e.preventDefault()
            let sc_category_id = suggest?.sc_category_id
            let listTrace = [];
            while (!!sc_category_id) {
                const category = listCategories?.find(c => c.id === sc_category_id);
                if (!!category) {
                    listTrace.unshift(category)
                    sc_category_id = category?.parent_id
                }
                else sc_category_id = null
            }
            if (listTrace.length > 0) {
                setFieldValue(prefix || "default_name", [...listTrace])
                onSelect(listTrace[listTrace.length - 1])
            }
            else {
                addToast(formatMessage({ defaultMessage: "Ngành hàng không xác định" }), { appearance: "error" })
            }
        }}
    >{suggest.category_path}</a>
}


const CircleProgress = () => {
    return (
        <div className="circle-progress mt-4 ml-4">
            <div className="rotate-ifinite" />
        </div>
    );
};